import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

import {
  FinnairBoundItem,
  FinnairDisruptedBoundItem,
  FinnairItineraryItemFlight,
  FinnairLocation,
  FinnairPassengerCode,
  FinnairPassengerItem,
} from '@fcom/dapi/api/models';

@Component({
  selector: 'fin-flight-card',
  templateUrl: './flight-card.component.html',
  styleUrls: ['./flight-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlightCardComponent implements OnChanges {
  @Input()
  flightOrBound: FinnairBoundItem | FinnairDisruptedBoundItem | FinnairItineraryItemFlight;
  @Input()
  title: string;
  @Input()
  dim = false;
  @Input()
  locations?: { [key: string]: FinnairLocation };
  @Input()
  passengers: FinnairPassengerItem[];
  @Input()
  hideModify = false;
  @Input()
  hideViewDetails = false;
  @Input()
  expanderOpen: boolean;
  @Input()
  roundedBottom = true;

  cardExpanderOpen: boolean;
  paxIcon: string;

  @Output()
  modifyClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  viewDetails: EventEmitter<void> = new EventEmitter<void>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['passengers']) {
      this.paxIcon = this.getPaxNumberIcon();
    }

    if (changes['expanderOpen']) {
      this.cardExpanderOpen = changes['expanderOpen'].currentValue;
    }
  }

  toggleOpenCard(isOpen: boolean): void {
    this.cardExpanderOpen = !isOpen;
  }

  private getPaxNumberIcon(): string {
    if (this.passengers.length === 1) {
      return 'single-pax';
    }

    return this.passengers.some(({ passengerTypeCode }) => passengerTypeCode === FinnairPassengerCode.INF)
      ? 'adult-infant'
      : 'multi-pax';
  }
}
